/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 17:04:34
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-22 18:13:17
 */
import { copy } from '@/utils/common';
import { getSourceUrl, getProductShareToken } from '@/api/shopManage';
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['isDarenPartner']),
	},
	methods: {
		async ksCopy(row) {
			const { third_product_id, activity_type, product_type, id } = row;
			try {
				if (+activity_type === 3 || +product_type === 4) {
					// 针对合作招商的商品 ,二级团的商品
					//复制口令
					let res = await getProductShareToken({ productId: id });
					copy(res?.data?.productShareToken);
				} else {
					// 快手复制商品ID
					copy(third_product_id);
				}

				this.$message.success('复制成功');
			} catch (e) {
				this.$message.success('复制失败');
			}
		},
		async dyNormalCopy(row) {
			const { product_url } = row;
			// 达人商务可以进行转链，其他人只能复制商品链接 保持不变
			this.isDarenPartner ? this.exchangeUrl(row) : (copy(product_url), this.$message.success('复制成功'));
		},
		spCopy(row) {
			const { product_url } = row;
			// 快手复制商品链接
			this.isDarenPartner ? this.exchangeUrl(row) : (copy(product_url), this.$message.success('复制成功'));
		},
		// 转链为专属链接
		async exchangeUrl({ product_id, cooperate_id }) {
			const {
				code,
				data: { pick_source },
			} = await getSourceUrl({ product_id, cooperate_id });
			if (code === 0) {
				copy(pick_source);
				this.$message.success('复制成功');
			}
		},
	},
};
